import Vue from "vue";
import Vuex from "vuex";
import { actions, mutations } from ".";
import { User } from "./../models/user.model";
import { City } from "./../models/city.model";
import { ToastMessage } from "./../models/toast-message.model";
import { authModule, namespaceAuth } from "./auth";
import { homeModule, namespaceHome } from "./home";
import { invitationsModule, namespaceInvitation } from "./invitation";
import { matchModule, namespaceMatch } from "./match";
import { namespacePositions, positionsModule } from "./positions";
import { namespaceReferees, refereesModule } from "./referees";
import { namespaceRoles, rolesModule } from "./roles";
import { namespaceSportEvent, sportEventModule } from "./sport-event";
import { namespaceSportEvents, sportEventsModule } from "./sport-events/index";
import { namespaceTeams, teamsModule } from "./teams";
import { namespaceTimeline, timelineModule } from "./timeline/index";

Vue.use(Vuex);
// TODO: Extend RootState
export interface RootState {
  toastMessages?: ToastMessage | ToastMessage[];
  cities: City[];
  users: User[];
  userSearch: string;
}

const state: RootState = {
  toastMessages: undefined,
  cities: [],
  users: [],
  userSearch: ""
};

export default new Vuex.Store<RootState>({
  state,
  actions,
  mutations,
  modules: {
    [namespaceAuth]: authModule,
    [namespaceHome]: homeModule,
    [namespaceSportEvent]: sportEventModule,
    [namespaceSportEvents]: sportEventsModule,
    [namespaceMatch]: matchModule,
    [namespaceTeams]: teamsModule,
    [namespaceRoles]: rolesModule,
    [namespacePositions]: positionsModule,
    [namespaceReferees]: refereesModule,
    [namespaceInvitation]: invitationsModule,
    [namespaceTimeline]: timelineModule
  }
});

export * from "./root-actions";
export * from "./root-mutations";
